import {useQuery} from '@tanstack/react-query';
import {get} from '../utils'
import {MODULES, QUERY_KEYS} from "../../config/constants";

async function getReportFields({queryKey}) {
  // eslint-disable-next-line no-unused-vars
  const [_key, {module}] = queryKey;
  if (!module || ![MODULES.ID_TALENT_ACQUISITION].includes(module)) return;
  return await get(`/api/module/${module}/report_fields`);
}

export default function useReportFields(module) {
  return useQuery([`${module}:${QUERY_KEYS.REPORT_FIELDS}`, {module}], getReportFields)
}